import * as React from 'react';
import Modal from '@material-ui/core/Modal';
import { Button } from 'reactstrap';
import AlertModal from '../../../../shared/components/Modal';
import moment from 'moment';

const RequestReschedule = ({ opened, closeModal, motivo_reagendamiento, id_admision }) => {

    const [reasonReschedule, setReasonReschedule] = React.useState(null);
    const [showAlertModal, setAlerShowModal] = React.useState(false);
    const [messagAlerteModal, setAlertMessageModal] = React.useState(null);
    const [colorAlertModal, setAlertColorModal] = React.useState("success");

    React.useEffect(() => {

    }, []);

    const onOkAlertModal = () => {
        switch (colorAlertModal) {
            case "success":
                setAlertColorModal("info");
                setAlertMessageModal("");
                setAlerShowModal(false);
                closeModal();
                break;
            case "warning":
                sendRequestRescheduleAdmission();
                break;
            case "danger":
                setAlertColorModal("info");
                setAlertMessageModal("");
                setAlerShowModal(false);
                break;
        }
    }

    const ToggleAlertModal = () => {
        switch (colorAlertModal) {
            case "success":
                setAlertColorModal("info");
                setAlertMessageModal("");
                setAlerShowModal(false);
                closeModal();
                break;
            case "warning":
                setAlertColorModal("info");
                setAlertMessageModal("");
                setAlerShowModal(false);
                break;
            case "danger":
                setAlertColorModal("info");
                setAlertMessageModal("");
                setAlerShowModal(false);
                break;
        }
    }

    const sendRequestRescheduleAdmission = async () => {
        let usuario = JSON.parse(sessionStorage.getItem('usuario'));
        let dataSend = {
            id_admision: id_admision,
            motivo_reagendamiento: reasonReschedule,
            id_usuario: usuario.id_usuario,
            fecha_solicitud_reasignacion: moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        };
        await fetch(process.env.REACT_APP_PUBLIC_URL + 'admision/solicitar-reagendamiento', {
            method: 'PUT',
            headers: {
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(dataSend)
        }).then((response) => {
            if (response.status != 500 && response.status != 403 && response.status != 404) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then(response => {
            setAlertColorModal("success");
            setAlertMessageModal("Admisión Reagendada con Exito");
            setAlerShowModal(true);
        }).catch((err) => {
            console.log(err);
            setAlertColorModal("danger");
            setAlertMessageModal("Ha ocurrido un error en el Servidor");
            setAlerShowModal(true);
        });
    }

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Reagendar Admisión</h5>
                        </div>
                    </div>

                    <div className="form">
                        <div className="form__form-group">
                            <span className="form__form-group-label">Motivo de Reagendamiento</span>
                            <div className="form__form-group-field">
                                <textarea
                                    value={reasonReschedule}
                                    name="textarea-reschedule"
                                    onChange={(e) => {
                                        setReasonReschedule(e.target.value);
                                    }}
                                >
                                </textarea>
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                setAlertColorModal("warning");
                                setAlertMessageModal("Usted esta seguro de solicitar el Reagendamiento de la Admisión");
                                setAlerShowModal(true);
                            }}
                        >
                            Guardar
                        </Button>
                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            <AlertModal
                color={colorAlertModal}
                title={messagAlerteModal}
                modal={showAlertModal}
                onOk={() => onOkAlertModal()}
                toggle={() => ToggleAlertModal(false)}
            />
        </div>
    );
};
export default RequestReschedule;
